import {DbDate} from './db-date';
import {DbDateStruct} from './date-struct';
import {DayTemplateContext} from './datepicker-day-template-context';
import {TranslationWidth} from '@angular/common';

export type NgbMarkDisabled = (date: DbDateStruct, current?: {year: number, month: number}) => boolean;
export type NgbDayTemplateData = (date: DbDateStruct, current?: {year: number, month: number}) => any;

export type DayViewModel = {
  date: DbDate,
  context: DayTemplateContext,
  tabindex: number,
  ariaLabel: string,
  hidden: boolean
};

export type WeekViewModel = {
  number: number,
  days: DayViewModel[],
  collapsed: boolean
};

export type MonthViewModel = {
  firstDate: DbDate,
  lastDate: DbDate,
  number: number,
  year: number,
  weeks: WeekViewModel[],
  weekdays: string[]
};

// clang-format off
export type DatepickerViewModel = {
  dayTemplateData: NgbDayTemplateData | null,
  disabled: boolean,
  displayMonths: number,
  firstDate: DbDate | null,
  firstDayOfWeek: number,
  focusDate: DbDate | null,
  focusVisible: boolean,
  lastDate: DbDate | null,
  markDisabled: NgbMarkDisabled | null,
  maxDate: DbDate | null,
  minDate: DbDate | null,
  months: MonthViewModel[],
  navigation: 'select' | 'arrows' | 'none',
  outsideDays: 'visible' | 'collapsed' | 'hidden',
  prevDisabled: boolean,
  nextDisabled: boolean,
  selectBoxes: {
    years: number[],
    months: number[]
  },
  selectedDate: DbDate | null,
  weekdayWidth: TranslationWidth,
  weekdaysVisible: boolean
};
// clang-format on

export enum NavigationEvent {
  PREV,
  NEXT
}
